import React from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import WarningIcon from '@material-ui/icons/Warning';
import Off from '@material-ui/icons/ToggleOff';
import { DotsIcon, CheckIcon, DangerIcon } from '../../../../images/icons/WrapSvg';

import Menu from './TableMenu';
import DuplicateMenu from './DuplicateMenu';

function isOk(element, filter) {
    if (
        !filter ||
        (filter &&
            element.configurado !== undefined &&
            filter.toString() === element.configurado.toString())
    ) {
        return true;
    } else {
        return false;
    }
}

class Index extends React.Component {
    state = {
        anchorEl: null,
        result: [],
        data: [],
        filtro: undefined,
        duplicated: false,
    };

    static getDerivedStateFromProps(props, state) {
        if (
            props.locals &&
            (props.locals !== state.data ||
                props.window_searchs !== state.search ||
                props.filtro !== state.filtro)
        ) {
            const { locals, window_searchs, filtro } = props;

            state.filtro = filtro ? filtro : undefined;
            state.data = locals ? locals : [];
            state.search = window_searchs ? window_searchs : [];
            state.result = []
                .concat(locals)
                .sort((a, b) =>
                    a.ruta.toUpperCase().trim() < b.ruta.toUpperCase().trim()
                        ? -1
                        : a.ruta.toUpperCase().trim() > b.ruta.toUpperCase().trim()
                        ? 1
                        : a.nombre.toUpperCase().trim() < b.nombre.toUpperCase().trim()
                        ? -1
                        : 1,
                )
                .reduce((arr, info) => {
                    if (window_searchs && window_searchs.length > 0) {
                        const filter = window_searchs.filter(
                            (s) =>
                                info.nombre &&
                                (info.nombre.toUpperCase().includes(s) ||
                                    info.ruta.toUpperCase().includes(s)),
                        );
                        if (filter && filter.length > 0 && isOk(info, filtro)) {
                            arr.push(info);
                        }
                    } else if (isOk(info, filtro)) {
                        arr.push(info);
                    }
                    return arr;
                }, []);
            return state;
        }
        return null;
    }

    handleClick = (event, id) => {
        this.setState({ anchorEl: event.currentTarget, id: id });
    };

    handleClose = (action) => {
        if (action === 'duplicated') {
            this.setState({ anchorEl: null, duplicated: true });
        } else {
            this.setState({ anchorEl: null, id: null, duplicated: false });
        }
    };

    handleDuplicated = (local) => {
        if (local) {
            this.props.duplicated(
                local,
                this.state.id,
                this.props.locals.find((f) => f.id === this.state.id).configurado === 0,
            );
        }
        this.setState({ duplicated: false });
    };

    render() {
        const { intl } = this.props;
        const { anchorEl, result, id, duplicated } = this.state;
        return (
            <Paper className={'locals_table_paper bg_ice_blue'}>
                <Table className={'locals_table_table'}>
                    <TableHead>
                        <TableRow className={'locals_table_row'}>
                            <TableCell className={'barlow_regular_small c_greyish_brown upper'}>
                                {intl.formatMessage({ id: 'local_table_name' })}
                            </TableCell>
                            <TableCell className={'barlow_regular_small c_greyish_brown upper'}>
                                {intl.formatMessage({ id: 'local_table_reference' })}
                            </TableCell>
                            <TableCell className={'barlow_regular_small c_greyish_brown upper'}>
                                {intl.formatMessage({ id: 'local_table_configurance' })}
                            </TableCell>
                            <TableCell align="right" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {result &&
                            result.length > 0 &&
                            result.map((n) => {
                                return (
                                    <TableRow
                                        hover
                                        key={n.id}
                                        className={'locals_table_row hand'}
                                        classes={{ hover: 'locals_table_hover' }}
                                    >
                                        <TableCell
                                            className={'barlow_regular_small c_dark_grey_blue'}
                                            component="th"
                                            scope="row"
                                        >
                                            {n.nombre}
                                        </TableCell>
                                        <TableCell
                                            className={'barlow_regular_small c_dark_grey_blue'}
                                        >
                                            {n.ruta}
                                        </TableCell>
                                        <TableCell
                                            className={'barlow_regular_small c_dark_grey_blue'}
                                        >
                                            {n.configurado === 3 && (
                                                <div className="align_center display_flex">
                                                    <CheckIcon className="c_pea margin_right_6" />
                                                    <FormattedMessage id="local_table_configurance_yes" />
                                                </div>
                                            )}
                                            {n.configurado === 2 && (
                                                <div className="align_center display_flex">
                                                    <Off className="c_cool_grey_two margin_right_6" />
                                                </div>
                                            )}
                                            {n.configurado === 1 && (
                                                <div className="align_center display_flex">
                                                    <WarningIcon className="c_golden_yellow margin_right_6" />
                                                    <FormattedMessage id="local_table_configurance_partial" />
                                                </div>
                                            )}
                                            {n.configurado === 0 && (
                                                <div className="align_center display_flex">
                                                    <DangerIcon className="c_lipstick margin_right_6" />
                                                    <FormattedMessage id="local_table_configurance_no" />
                                                </div>
                                            )}
                                        </TableCell>
                                        <TableCell align="right" className={'locals_table_dots'}>
                                            <Button
                                                size="small"
                                                color="primary"
                                                aria-label="add"
                                                className={'locals_table_button'}
                                                onClick={(e) => this.handleClick(e, n.id)}
                                            >
                                                <DotsIcon />
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
                {anchorEl && <Menu anchorEl={anchorEl} id={id} handleClose={this.handleClose} />}
                {duplicated && <DuplicateMenu locals={result} onClose={this.handleDuplicated} />}
            </Paper>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(withRouter(Index));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/locals/Table.js